import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import { withRouter } from 'react-router-dom';
import { BaseComponent } from '@components/Base/h5/BaseComponent';
import type { BaseRouteComponentProps } from 'types/base';
import InfiniteScrollList from '@components/InfiniteScrollList';
import CountDown from "@components/countDown";
import updateImageListSrc from "@utils/update-image-list-src";
import { formatNumberToWan } from '@utils/formatNumber';

interface ProductListProps extends BaseRouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    loading?: boolean;
    hasMore?: boolean;
    emptyIcon?: any;
    emptyText?: string;
    emptyBoxStyle?: any;
    onLoadMore?: () => void;
    list: any[];
    tabIndex?: number;
    goProductDetailClick?: Function;
}

@inject('app', 'site', 'user')
@observer
class ProductList extends BaseComponent<ProductListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    // 跳转到新品详情页
    goProductDetail = (code: string, item: any) => {
        // let { user } = this.props;
        // if (!user?.userInfo?.code) {
        //     const { user } = this.props as any;
        //     if (user && typeof user.checkLogin === 'function') {
        //         const isLogin = user.checkLogin();
        //         if (!isLogin) {
        //             return;
        //         }
        //     }
        //     // Toast.info({ content: '请先登录!' });
        //     return;
        // }
        this.props.history.push(`/productDetail/${code}`);
        // window.open(`/productDetail/${id}`);
        this.props.goProductDetailClick && this.props.goProductDetailClick();
    }

    // 渲染试用产品按钮（tabIndex === 0）
    renderProductButton = (child: any) => {
        let { user } = this.props;
        console.log(user, '用户信息');
        // status === 0   即将开始
        // status === 1 && myEnrollStatus === null   立即报名
        // (status === 1 || status === 2) && myEnrollStatus ==  0    // 已报名待公布
        // status === 2 && myEnrollStatus === null     // 入选名单待公布
        // status === 3 && myEnrollStatus === null   // 第一轮名单公布
        // status === 4 && myEnrollStatus === null   // 第二轮名单公布
        // myEnrollStatus === 1   // 恭喜您第一轮入选
        // myEnrollStatus === 2   // 恭喜您第二轮入选
        // status === 3 && myEnrollStatus === 0   // 第一轮未入选
        // status === 4 && myEnrollStatus === 0   // 很遗憾您未入选
        const { status, myEnrollStatus } = child;

        // status === 0   即将开始
        if (status === 0) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn1}
                >
                    即将开始
                </div>
            );
        }

        // status === 1 && myEnrollStatus === null   立即报名
        if (status === 1 && myEnrollStatus === null) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn}
                >
                    立即报名
                </div>
            );
        }

        // (status === 1 || status === 2) && myEnrollStatus === 0   已报名待公布
        if ((status === 1 || status === 2) && myEnrollStatus === 0) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn1}
                >
                    <img src={user.userInfo?.avatarUrl} alt="" className={styles.avatar} />
                    <div className={styles.text}>已报名待公布名单</div>
                </div>
            );
        }

        // status === 2 && myEnrollStatus === null    入选名单待公布
        if (status === 2 && myEnrollStatus === null) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn1}
                >
                    入选名单待公布
                </div>
            );
        }

        // status === 3 && myEnrollStatus === null   第一轮名单公布
        if (status === 3 && myEnrollStatus === null) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn1}
                >
                    第一轮名单公布
                </div>
            );
        }

        // status === 4 && myEnrollStatus === null   第二轮名单公布
        if (status === 4 && myEnrollStatus === null) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn1}
                >
                    第二轮名单公布
                </div>
            );
        }

        // myEnrollStatus === 1   恭喜您第一轮入选
        if (myEnrollStatus === 1) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn1}
                >
                    <img src={user.userInfo?.avatarUrl} alt="" className={styles.avatar} />
                    <div className={styles.text}>恭喜您第一轮入选</div>
                </div>
            );
        }

        // myEnrollStatus === 2   恭喜您第二轮入选
        if (myEnrollStatus === 2) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn1}
                >
                    <img src={user.userInfo?.avatarUrl} alt="" className={styles.avatar} />
                    <div className={styles.text}>恭喜您第二轮入选</div>
                </div>
            );
        }

        // status === 3 && myEnrollStatus === 0   第一轮未入选
        if (status === 3 && myEnrollStatus === 0) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn2}
                >
                    <img src={user.userInfo?.avatarUrl} alt="" className={styles.avatar} />
                    <div className={styles.text}>第一轮未入选</div>
                </div>
            );
        }

        // status === 4 && myEnrollStatus === 0   很遗憾您未入选
        if (status === 4 && myEnrollStatus === 0) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn2}
                >
                    <img src={user.userInfo?.avatarUrl} alt="" className={styles.avatar} />
                    <div className={styles.text}>很遗憾您未入选</div>
                </div>
            );
        }
        
        return null;
    }

    // 渲染我的试用按钮（tabIndex === 1）
    renderMyTrialButton = (child: any) => {
        let { user } = this.props;
        const { myEnrollStatus, status } = child;
        if ((status === 1 || status === 2) && myEnrollStatus === 0) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn1}
                >
                    <img src={user.userInfo?.avatarUrl} alt="" className={styles.avatar} />
                    <div className={styles.text}>已报名待公布名单</div>
                </div>
            );
        }
        // myEnrollStatus === 1   恭喜您第一轮入选
        if (myEnrollStatus === 1) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn1}
                >
                    <img src={user.userInfo?.avatarUrl} alt="" className={styles.avatar} />
                    <div className={styles.text}>恭喜您第一轮入选</div>
                </div>
            );
        }
        // myEnrollStatus === 2   恭喜您第二轮入选
        if (myEnrollStatus === 2) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn1}
                >
                    <img src={user.userInfo?.avatarUrl} alt="" className={styles.avatar} />
                    <div className={styles.text}>恭喜您第二轮入选</div>
                </div>
            );
        }
        // status === 3 && myEnrollStatus === 0   第一轮未入选
        if (status === 3 && myEnrollStatus === 0) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn2}
                >
                    <img src={user.userInfo?.avatarUrl} alt="" className={styles.avatar} />
                    <div className={styles.text}>第一轮未入选</div>
                </div>
            );
        }
        // status === 4 && myEnrollStatus === 0   很遗憾您未入选
        if (status === 4 && myEnrollStatus === 0) {
            return (
                <div 
                    onClick={() => this.goProductDetail(child.id, child)} 
                    className={styles.trialPrimaryBtn2}
                >
                    <img src={user.userInfo?.avatarUrl} alt="" className={styles.avatar} />
                    <div className={styles.text}>很遗憾您未入选</div>
                </div>
            );
        }
    }

    // 渲染产品信息区域（价格、名额、报名数）
    renderProductInfo = (child: any) => {
        const { tabIndex } = this.props;
        
        // if (tabIndex !== 0 && tabIndex != null) return null;
        
        return (
            <>
                {child.status >= 2 && (
                    <div className={styles.trialPrice}>
                        市场价：<span className={styles.priceNum}>{child.price}</span>
                    </div>
                )}
                <div className={styles.personNumBox}>
                    <div className={styles.personNum}>
                        <img src={`${BASE_IMG_URL}/product/icon1.png`} alt="" className={styles.icon}/>
                        <div className={styles.text}>{child.recruit}个名额</div>
                    </div>
                    <div className={styles.personNum}>
                        <img src={`${BASE_IMG_URL}/product/icon2.png`} alt="" className={styles.icon}/>
                        <div className={styles.text}>{formatNumberToWan(child.enrolls)}人报名</div>
                    </div>
                </div>
            </>
        );
    }

    // 渲染状态文本（我的试用页面）
    renderStatusText = (child: any) => {
        const { tabIndex } = this.props;
        
        if (tabIndex !== 1) return null;
        
        return (
            <>
                {child.status <= 2 && (
                    <div className={styles.userStatusText}>
                        第一轮名单公布：{child.firstRoundAt?.replace(/\//g, '-')}
                    </div>
                )}
                {child.status === 3 && (
                    <div className={styles.userStatusText}>
                        第二轮名单公布：{child.secondRoundAt?.replace(/\//g, '-')}
                    </div>
                )}
            </>
        );
    }

    // 渲染单个列表项
    renderProductItem = (child: any, index: number) => {
        const { tabIndex } = this.props;
        
        return (
            <React.Fragment key={child.id || index}>
                <div className={styles.trialItemBox}>
                    {(child.historySplitShow && index !== 0) && (
                        <div className={styles.listLines}></div>
                    )}
                    <div className={styles.trialItem} onClick={() => this.goProductDetail(child.code, child)}>
                        <div className={styles.trialLeft}>
                            <img 
                                src={updateImageListSrc(child.trialImage?.[0], 15)} 
                                className={styles.trialImg}
                                loading="lazy"
                                alt={child.title}
                            /> 
                        </div>
                        
                        <div className={styles.trialRight}>
                            <div className={styles.rightTop}>
                                <div className={styles.trialTitle}>
                                    {child.productType ? '【' + child.productType + '】' + child.title : child.title}
                                </div>
                                
                                {this.renderProductInfo(child)}
                                
                                {child.status < 2 && (
                                    <div className={styles.countdownBox}>
                                        <CountDown number={child.status == 0 ? child.enrollStartAt : child.enrollEndAt} endText={child.status == 0 ? '后开始' : '后结束'}/>
                                    </div>
                                )}
                                
                                {/* {this.renderStatusText(child)} */}
                            </div>
                            <div className={styles.triaBm}>
                                {(tabIndex === 0 || tabIndex == null) && (
                                    <div className={styles.trialBottom}>
                                        {this.renderProductButton(child)}
                                    </div>
                                )}
                                
                                {tabIndex === 1 && (
                                    <div className={styles.trialBottom}>
                                        {this.renderMyTrialButton(child)}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {((child.linkTitle && child.linkAddress != 0) && (tabIndex == 0 || !!!tabIndex)) &&
                        <div className={styles.intell} onClick={() => {
                            // this.props.history.push(`/threadDetail/${child.linkAddress}`);
                            window.open(`${child.linkAddress}`)
                        }}>
                        <div className={styles.intellText}>{child.linkTitle}</div>
                        <img className={styles.intellImg} src={`${BASE_IMG_URL}/product/jt5.png`} /></div>
                    }
                </div>
                
            </React.Fragment>
        );
    }

    renderContent() {
        const { 
            list = [], 
            loading = false, 
            hasMore = true, 
            emptyText, 
            emptyIcon, 
            emptyBoxStyle, 
            onLoadMore 
        } = this.props;

        if (!Array.isArray(list)) return null;

        return (
            <div className={styles.trialList}>
                <InfiniteScrollList
                    variant="h5"
                    data={list}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore || (() => {})}
                    renderItem={(item, index) => this.renderProductItem(item, index)}
                    threshold={100}
                    emptyText={emptyText || '暂无数据'}
                    emptyIcon={emptyIcon || `${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={emptyBoxStyle}
                    loadingText="加载中..."
                    noMoreText="没有更多了"
                />
            </div>
        );
    }

    render() {
        return this.renderContent();
    }
}

export default withRouter(ProductList);